import React, { useEffect, useState } from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import Skeleton from "react-loading-skeleton";
import { Tag } from "antd";
import CustomPagination from "../util/CustomPagination";
import StarRating from "../util/StarRating";
import './assets/css/hospital.css';
import ApiService from "../util/ApiService";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import AuthService from "../../../admin/components/login/AuthService";
import LoadingScreen from "../util/LoadingScreen"; // Importando o componente global de carregamento
import dayjs from 'dayjs';
const ContentHospital = ({ hospital, ratings, loading }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loadingDuty, setLoadingDuty] = useState(true);
    const [loadingPage, setLoadingPage] = useState(false); // Estado para o carregamento global da página
    const [noResults, setNoResults] = useState(false);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0, lastPage: 0 });
    const [duties, setDuties] = useState([]);

    const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

    const mapContainerStyle = {
        height: "400px",
        width: "100%",
    };

    const mapCenter = {
        lat: parseFloat(hospital?.latitude) || -24.9923319,
        lng: parseFloat(hospital?.longitude) || 135.2252427,
    };

    const mapOptions = {
        zoomControl: true,
        clickableIcons: false,
        styles: [
            {
                featureType: "poi",
                elementType: "labels",
                stylers: [{ visibility: "off" }],
            },
        ],
    };

    useEffect(() => {
        if (AuthService.isAuthenticated()) {
            setIsAuthenticated(true);
        }
    }, []);

    const handleInterestClick = (dutyId, hasInterest) => {
        setLoadingPage(true); // Ativando o carregamento global da página

        const endpoint = hasInterest ? "duty/disable-interest" : "duty/accept";
        const action = hasInterest ? "cancelado" : "registrado";

        ApiService.send(
            hasInterest ? "delete" : "post",
            `${process.env.REACT_APP_URL_API}${endpoint}`,
            { id: dutyId },
            true
        )
            .then(() => {
                Swal.fire({
                    title: "Sucesso",
                    text: `Manifestação de interesse ${action} com sucesso!`,
                    icon: "success",
                    confirmButtonText: "OK",
                });

                setDuties((prevDuties) =>
                    prevDuties.map((duty) =>
                        duty.id === dutyId ? { ...duty, interest_status: !hasInterest, interest: hasInterest ? 0 : 1 } : duty
                    )
                );
            })
            .catch((error) => {
                Swal.fire({
                    title: "Erro",
                    text: `${error.response?.data?.message || "Ocorreu um erro"}`,
                    icon: "error",
                    confirmButtonText: "OK",
                });
            })
            .finally(() => {
                setLoadingPage(false); // Desativando o carregamento global da página
            });
    };

    const fetchDuties = async (page = 1) => {
        setLoadingDuty(true); // Ativa o estado de carregamento dos plantões

        const params = {
            page: page,
            pagination: pagination.pageSize,
            hospital: hospital.id,
        };

        try {
            const response = await ApiService.send("post", process.env.REACT_APP_URL_API + "duty/duty-record", params, false);

            const { data, pagination: pagInfo } = ApiService.handleApiResponse(response);
            setDuties(data || []);
            setPagination(pagInfo || { current: 1, pageSize: 10, total: 0 });


            if (data.length === 0) {
                setNoResults(true);
            } else {
                setNoResults(false);
            }
        } catch (error) {
            ApiService.handleApiError(error);
            setNoResults(true);
        } finally {
            setLoadingDuty(false);
        }
    };

    // Chamar fetchDuties sempre que a página ou hospital mudar
    useEffect(() => {
        if (hospital?.id) {
            fetchDuties();
        }
    }, [hospital]);

    const handlePageChange = (page) => {
        fetchDuties(page);
    };

    return (
        <>
            {loadingPage && <LoadingScreen />} {/* Carregamento global na página */}
            <div>
                <div className="card">
                    <div className="card-body pt-0">
                        <nav className="user-tabs mb-4">
                            <ul className="nav nav-tabs nav-tabs-bottom nav-justified">
                                <li className="nav-item">
                                    <a className="nav-link active" href="#doc_overview" data-bs-toggle="tab">
                                        Plantões Disponíveis
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="#doc_locations" data-bs-toggle="tab">
                                        Localização
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="#doc_reviews" data-bs-toggle="tab">
                                        Avaliações
                                    </a>
                                </li>
                            </ul>
                        </nav>
                        <div className="tab-content pt-0">
                            <div role="tabpanel" id="doc_overview" className="tab-pane fade show active">
                                <div className="row">
                                    <div className="col-md-12 col-lg-12">
                                        <div className="row">
                                            {loadingDuty ? (
                                                <Skeleton height={150}/>
                                            ) : duties.length > 0 ? (
                                                duties.map((duty) => (
                                                    <div className="col-12 col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-4"
                                                         key={duty.id}>
                                                        <div className="plantao-card">
                                                            <div className="pro-content">
                                                                <ul className="available-info mt-2">
                                                                    <li>
                                                                        <i className="fa fa-hospital"></i> {duty.department.name}
                                                                    </li>
                                                                    <li>
                                                                        <i className="far fa-calendar me-2"></i> {dayjs(duty.date_time).format("DD/MM/YYYY HH:mm")}

                                                                    </li>
                                                                    <li>
                                                                        <i className="fa fa-calendar me-2"></i> {dayjs(duty.date_time_end).format("DD/MM/YYYY HH:mm")}

                                                                    </li>
                                                                    <li>
                                                                        <i className="fa fa-money-bill-alt"></i> R$ {duty.value}{" "}
                                                                    </li>
                                                                    {duty.observation && (
                                                                        <li>
                                                                            <i className="fa fa-file-alt"></i>
                                                                            {duty.observation.length > 100 ? `${duty.observation.substring(0, 100)}...` : duty.observation}
                                                                        </li>
                                                                    )}
                                                                </ul>
                                                                <div className="specialties-tags mt-2">
                                                                    {duty.specialties.map((specialty) => (
                                                                        <Tag color="blue" key={specialty.id}>
                                                                            {specialty.name}
                                                                        </Tag>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                            <div className="row row-sm align-items-end">
                                                                <div
                                                                    className="col-12 d-flex justify-content-end align-items-end">
                                                                    {duty.interest_status && duty.interest === 1 ? (
                                                                        <button type="button"
                                                                            className="btn btn-sm btn-danger btn-block"
                                                                            onClick={() => handleInterestClick(duty.id, true)}
                                                                        >
                                                                            <i className="fa fa-minus"></i> Cancelar Interesse
                                                                        </button>
                                                                    ) : duty.accept_user == null ? (
                                                                        <button type="button"
                                                                            className="btn btn-sm btn-info btn-block btn-interest"
                                                                            onClick={() => handleInterestClick(duty.id, false)}
                                                                        >
                                                                            <i className="fa fa-plus"></i> Interesse
                                                                        </button>
                                                                    ) : null}


                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="alert alert-primary" role="alert">
                                                  Não foram encontrados plantões
                                                        disponíveis.
                                                </div>
                                            )}
                                        </div>
                                        <div className="load-more text-center">
                                            <CustomPagination
                                                pagination={pagination}
                                                onChange={handlePageChange}/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div role="tabpanel" id="doc_locations" className="tab-pane fade" style={{height: "400px"}}>

                                <div className="map-container">
                                    {loading ? (
                                        <div>Carregando...</div>
                                    ) : (
                                        <LoadScript googleMapsApiKey={googleMapsApiKey}>
                                            <GoogleMap
                                                mapContainerStyle={mapContainerStyle}
                                                center={mapCenter}
                                                zoom={15}
                                                options={mapOptions}
                                            >
                                                {/* Verifica se há coordenadas válidas antes de adicionar o Marker */}
                                                {mapCenter.lat && mapCenter.lng && (
                                                    <Marker
                                                        position={mapCenter}
                                                        title={hospital?.social_reason || "Local"}
                                                    />
                                                )}
                                            </GoogleMap>
                                        </LoadScript>
                                    )}
                                </div>
                            </div>
                            <div role="tabpanel" id="doc_reviews" className="tab-pane fade">
                                <div className="widget review-listing">
                                    <ul className="comments-list">
                                        {ratings && ratings.length > 0 ? (
                                            ratings.map((rating, index) => (
                                                <li key={index}>
                                                    <div className="comment">
                                                        <img
                                                            className="avatar avatar-sm rounded-circle"
                                                            alt="User Image"
                                                            src={rating.profile_image || process.env.REACT_APP_URL_STORAGE + "src/perfil_icone.png"}
                                                        />
                                                        <div className="comment-body">
                                                            <div className="meta-data">
                                                                <span
                                                                    className="comment-author">{rating.user_name}</span>
                                                                <span className="comment-date">
                                                                    Data avaliação {new Date(rating.created_at).toLocaleDateString("pt-BR")}
                                                                </span>
                                                            </div>
                                                            <p>
                                                                <br/>
                                                                <StarRating rating={rating.rating}/>
                                                            </p>
                                                            {rating.rating >= 3 && (
                                                                <p className="recommended">
                                                                    <i className="far fa-thumbs-up"></i> Recomendado
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>
                                                </li>
                                            ))
                                        ) : (
                                            <div className="alert alert-primary" role="alert">Nenhuma avaliação
                                                encontrada.</div>
                                        )}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ContentHospital;
